import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  icon: '📘',
  num: '1',
  title: 'La Biblia del Espacio Reducido',
  project: 'Repisa plegable de pared'
}, {
  icon: '📗',
  num: '2',
  title: 'Mesas y Escritorios Rebatibles',
  project: 'Mesa con pistón neumático'
}, {
  icon: '📙',
  num: '3',
  title: 'Estanterías e Islas Móviles',
  project: 'Isla de cocina transformable'
}, {
  icon: '📕',
  num: '4',
  title: 'Dormitorios Inteligentes',
  project: 'Cama Murphy con escritorio'
}, {
  icon: '📓',
  num: '5',
  title: 'Sillería y Bancos Plegables',
  project: 'Silla ergonómica maciza'
}, {
  icon: '📔',
  num: '6',
  title: 'El Taller Plegable',
  project: 'Estación con tornillo de banco'
}];
const features = ['Planos con medidas reales verificadas', 'Lista de herrajes ARS 2024', 'Checklist de armado paso a paso', 'Protocolo de instalación segura', 'Control de calidad antes de instalar'];
export function ProductTomos() {
  return <section className="py-12 md:py-16 bg-cream" data-id="element-195">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-196">
        <div className="text-center mb-10" data-id="element-197">
          <motion.h2 initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-black text-wood-dark mb-2" data-id="element-198">
            EL SISTEMA COMPLETO
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl font-bold text-amber-dark mb-1" data-id="element-199">
            6 TOMOS + 6 BONOS
          </motion.p>
          <p className="text-sm text-charcoal/60" data-id="element-200">
            480 páginas · 30 modelos · 48 checklists · Listo para fabricar hoy
          </p>
        </div>

        <h3 className="text-2xl font-serif font-bold text-wood-dark mb-6 text-center" data-id="element-201">
          LOS 6 TOMOS
        </h3>

        {/* Table-style layout */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-warm overflow-hidden border border-wood-light/15 mb-10" data-id="element-202">
          <div className="hidden md:grid grid-cols-[60px_1fr_1fr] bg-wood-dark text-cream text-sm font-bold uppercase tracking-wider" data-id="element-203">
            <div className="p-3 text-center" data-id="element-204">Tomo</div>
            <div className="p-3" data-id="element-205">Título</div>
            <div className="p-3" data-id="element-206">Proyecto Estrella</div>
          </div>
          {tomos.map((tomo, index) => <div key={index} className={`grid grid-cols-1 md:grid-cols-[60px_1fr_1fr] border-b border-wood-light/10 last:border-b-0 ${index % 2 === 0 ? 'bg-white' : 'bg-cream-dark/50'}`} data-id="element-207">
              <div className="p-3 text-center text-2xl md:text-xl flex md:block items-center gap-3" data-id="element-208">
                <span data-id="element-209">{tomo.icon}</span>
                <span className="md:hidden text-base font-bold text-wood-dark" data-id="element-210">
                  {tomo.title}
                </span>
              </div>
              <div className="hidden md:flex p-3 items-center font-medium text-wood-dark" data-id="element-211">
                {tomo.title}
              </div>
              <div className="p-3 flex items-center text-sm text-amber-dark font-semibold md:border-l border-wood-light/10" data-id="element-212">
                <span className="md:hidden text-charcoal/60 mr-1" data-id="element-213">
                  Proyecto:
                </span>
                {tomo.project}
              </div>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-wood-dark text-cream rounded-2xl p-6 md:p-8 shadow-warm wood-texture" data-id="element-214">
          <h4 className="text-xl font-serif font-bold text-amber mb-5 text-center" data-id="element-215">
            Cada tomo incluye:
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-216">
            {features.map((f, i) => <div key={i} className="flex items-center text-sm" data-id="element-217">
                <CheckCircle2 className="w-5 h-5 text-amber mr-2 flex-shrink-0" data-id="element-218" />
                <span className="text-cream-dark/90" data-id="element-219">{f}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}